import React, { useState } from 'react';

import { Link, useNavigate } from 'react-router-dom';

import { useAuth } from '../../context/AuthContext';

import { useSiteSettings } from '../../context/SiteSettingsContext';

import { toast } from 'react-toastify';

import styled from 'styled-components';



const NIGERIAN_STATES = [

  'Abia','Adamawa','Akwa Ibom','Anambra','Bauchi','Bayelsa','Benue','Borno',

  'Cross River','Delta','Ebonyi','Edo','Ekiti','Enugu','FCT','Gombe','Imo',

  'Jigawa','Kaduna','Kano','Katsina','Kebbi','Kogi','Kwara','Lagos','Nasarawa',

  'Niger','Ogun','Ondo','Osun','Oyo','Plateau','Rivers','Sokoto','Taraba',

  'Yobe','Zamfara',

];



const MEMBERSHIP_CATEGORIES = [

  { value: 'fellow', label: 'Fellow (FNIS)' },

  { value: 'corporate', label: 'Corporate Member (MNIS)' },

  { value: 'associate', label: 'Associate Member' },

  { value: 'graduate', label: 'Graduate Member' },

  { value: 'student', label: 'Student Member' },

  { value: 'technician', label: 'Technician Member' },

  { value: 'probationer', label: 'Probationer' },

];



const STEPS = ['Account', 'Personal', 'Professional', 'Confirm'];



export default function Register() {

  const [step, setStep] = useState(0);

  const [formData, setFormData] = useState({

    email: '', first_name: '', last_name: '', password: '', password_confirm: '',

    phone_number: '', gender: '', date_of_birth: '',

    address: '', state_of_origin: '',

    membership_category: 'graduate', membership_number: '', shortcode: '',

    specialization: '', firm_name: '', firm_address: '',

    surcon_number: '', academic_qualification: '',

    registered_with_nis_hq: false,

  });

  const [photo, setPhoto] = useState(null);

  const [photoPreview, setPhotoPreview] = useState(null);

  const [loading, setLoading] = useState(false);

  const [showPassword, setShowPassword] = useState(false);

  const [showPasswordConfirm, setShowPasswordConfirm] = useState(false);

  const { register } = useAuth();

  const { settings: siteSettings } = useSiteSettings();

  const navigate = useNavigate();



  const handleChange = (e) => {

    const { name, value, type, checked } = e.target;

    setFormData({ ...formData, [name]: type === 'checkbox' ? checked : value });

  };



  const handlePhotoChange = (e) => {

    const file = e.target.files[0];

    if (file) {

      if (file.size > 2 * 1024 * 1024) {

        toast.error('Photo must be less than 2MB');

        return;

      }

      setPhoto(file);

      setPhotoPreview(URL.createObjectURL(file));

    }

  };



  const nextStep = () => {

    if (step === 0) {

      if (!formData.email || !formData.first_name || !formData.last_name || !formData.password || !formData.password_confirm) {

        toast.error('Please fill all required fields');

        return;

      }

      if (formData.password.length < 8) {

        toast.error('Password must be at least 8 characters');

        return;

      }

      if (formData.password !== formData.password_confirm) {

        toast.error('Passwords do not match');

        return;

      }

    }

    setStep((s) => Math.min(s + 1, STEPS.length - 1));

  };



  const prevStep = () => setStep((s) => Math.max(s - 1, 0));



  const handleSubmit = async (e) => {

    e.preventDefault();

    setLoading(true);

    try {

      const fd = new FormData();

      Object.entries(formData).forEach(([key, val]) => {

        if (val !== '' && val !== null && val !== undefined) {

          fd.append(key, val);

        }

      });

      if (photo) fd.append('photo', photo);

      await register(fd);

      toast.success(
        'Registration submitted! Your membership is pending admin approval. '
        + 'You will be able to log in once it is approved.',
        { autoClose: 8000 }
      );

      navigate('/login');

    } catch (err) {

      const errors = err.response?.data;

      if (errors) {

        const msg = Object.values(errors).flat().join(' ');

        toast.error(msg);

      } else {

        toast.error('Registration failed');

      }

    } finally {

      setLoading(false);

    }

  };



  return (

    <StyledWrapper>

      <div className="container">

        <div className="card">

          <img src={siteSettings?.header_logo || '/NIS ABJ LOGO.jpg'} alt="NIS FCT" className="logo" />

          <span className="title">Membership Registration</span>

          <p className="subtitle">NIS Abuja (FCT) Branch</p>



          {/* Step indicator */}

          <div className="stepper">

            {STEPS.map((label, i) => (

              <div key={label} className={`step-item ${i === step ? 'active' : ''} ${i < step ? 'done' : ''}`}>

                <div className="step-circle">{i < step ? '✓' : i + 1}</div>

                <span className="step-label">{label}</span>

              </div>

            ))}

          </div>



          <form onSubmit={handleSubmit}>

            {/* Step 0: Account Info */}

            {step === 0 && (

              <div className="step-content">

                <div className="section-title">Account Information</div>

                <div className="row">

                  <div className="inputBox">

                    <input type="text" name="last_name" required value={formData.last_name} onChange={handleChange} />

                    <span>Surname *</span>

                  </div>

                  <div className="inputBox">

                    <input type="text" name="first_name" required value={formData.first_name} onChange={handleChange} />

                    <span>Other Names *</span>

                  </div>

                </div>

                <div className="inputBox full">

                  <input type="email" name="email" required value={formData.email} onChange={handleChange} />

                  <span>Email Address *</span>

                </div>

                <div className="row">

                  <div className="inputBox">

                    <input type={showPassword ? 'text' : 'password'} name="password" required minLength={8} value={formData.password} onChange={handleChange} style={{ paddingRight: 40 }} />

                    <span>Password *</span>

                    <button type="button" tabIndex={-1} onClick={() => setShowPassword(v => !v)} aria-label={showPassword ? 'Hide password' : 'Show password'} title={showPassword ? 'Hide password' : 'Show password'} style={{ position: 'absolute', top: '50%', right: 8, transform: 'translateY(-50%)', background: 'transparent', border: 0, padding: 4, cursor: 'pointer', color: '#6b7280', display: 'flex', alignItems: 'center', justifyContent: 'center', zIndex: 2 }}>

                      {showPassword ? (

                        <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><path d="M17.94 17.94A10.94 10.94 0 0 1 12 20c-7 0-11-8-11-8a19.77 19.77 0 0 1 5.06-5.94"/><path d="M9.9 4.24A10.94 10.94 0 0 1 12 4c7 0 11 8 11 8a19.86 19.86 0 0 1-3.17 4.19"/><path d="M14.12 14.12A3 3 0 1 1 9.88 9.88"/><line x1="1" y1="1" x2="23" y2="23"/></svg>

                      ) : (

                        <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><path d="M1 12s4-8 11-8 11 8 11 8-4 8-11 8-11-8-11-8z"/><circle cx="12" cy="12" r="3"/></svg>

                      )}

                    </button>

                  </div>

                  <div className="inputBox">

                    <input type={showPasswordConfirm ? 'text' : 'password'} name="password_confirm" required value={formData.password_confirm} onChange={handleChange} style={{ paddingRight: 40 }} />

                    <span>Confirm Password *</span>

                    <button type="button" tabIndex={-1} onClick={() => setShowPasswordConfirm(v => !v)} aria-label={showPasswordConfirm ? 'Hide password' : 'Show password'} title={showPasswordConfirm ? 'Hide password' : 'Show password'} style={{ position: 'absolute', top: '50%', right: 8, transform: 'translateY(-50%)', background: 'transparent', border: 0, padding: 4, cursor: 'pointer', color: '#6b7280', display: 'flex', alignItems: 'center', justifyContent: 'center', zIndex: 2 }}>

                      {showPasswordConfirm ? (

                        <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><path d="M17.94 17.94A10.94 10.94 0 0 1 12 20c-7 0-11-8-11-8a19.77 19.77 0 0 1 5.06-5.94"/><path d="M9.9 4.24A10.94 10.94 0 0 1 12 4c7 0 11 8 11 8a19.86 19.86 0 0 1-3.17 4.19"/><path d="M14.12 14.12A3 3 0 1 1 9.88 9.88"/><line x1="1" y1="1" x2="23" y2="23"/></svg>

                      ) : (

                        <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><path d="M1 12s4-8 11-8 11 8 11 8-4 8-11 8-11-8-11-8z"/><circle cx="12" cy="12" r="3"/></svg>

                      )}

                    </button>

                  </div>

                </div>

              </div>

            )}



            {/* Step 1: Personal Details */}

            {step === 1 && (

              <div className="step-content">

                <div className="section-title">Personal Details</div>

                <div className="row">

                  <div className="inputBox">

                    <input type="tel" name="phone_number" value={formData.phone_number} onChange={handleChange} />

                    <span>Phone Number</span>

                  </div>

                  <div className="selectBox">

                    <label>Gender</label>

                    <select name="gender" value={formData.gender} onChange={handleChange}>

                      <option value="">Select</option>

                      <option value="male">Male</option>

                      <option value="female">Female</option>

                    </select>

                  </div>

                </div>

                <div className="row">

                  <div className="inputBox">

                    <input type="date" name="date_of_birth" value={formData.date_of_birth} onChange={handleChange} className="has-value" />

                    <span>Date of Birth</span>

                  </div>

                  <div className="selectBox">

                    <label>State of Origin</label>

                    <select name="state_of_origin" value={formData.state_of_origin} onChange={handleChange}>

                      <option value="">Select State</option>

                      {NIGERIAN_STATES.map((st) => (

                        <option key={st} value={st}>{st}</option>

                      ))}

                    </select>

                  </div>

                </div>

                <div className="inputBox full">

                  <textarea name="address" value={formData.address} onChange={handleChange} rows={2} />

                  <span className={formData.address ? 'floated' : ''}>Residential Address</span>

                </div>

                <div className="photo-upload">

                  <label className="photo-label">Passport Photograph</label>

                  <div className="photo-area">

                    {photoPreview ? (

                      <img src={photoPreview} alt="Preview" className="photo-preview" />

                    ) : (

                      <div className="photo-placeholder">

                        <svg width="36" height="36" viewBox="0 0 24 24" fill="none" stroke="#0B5D1E" strokeWidth="1.5"><rect x="3" y="3" width="18" height="18" rx="3"/><circle cx="12" cy="10" r="3"/><path d="M6 21v-1a6 6 0 0 1 12 0v1"/></svg>

                        <span>Click to upload</span>

                      </div>

                    )}

                    <input type="file" accept="image/*" onChange={handlePhotoChange} />

                  </div>

                  <span className="photo-hint">Max 2MB — JPG, PNG</span>

                </div>

              </div>

            )}



            {/* Step 2: Professional Info */}

            {step === 2 && (

              <div className="step-content">

                <div className="section-title">Professional Information</div>

                <div className="row">

                  <div className="selectBox">

                    <label>Membership Category</label>

                    <select name="membership_category" value={formData.membership_category} onChange={handleChange}>

                      {MEMBERSHIP_CATEGORIES.map((c) => (

                        <option key={c.value} value={c.value}>{c.label}</option>

                      ))}

                    </select>

                  </div>

                  <div className="inputBox">

                    <input type="text" name="membership_number" value={formData.membership_number} onChange={handleChange} />

                    <span>Membership No.</span>

                  </div>

                </div>

                <div className="row">

                  <div className="inputBox">

                    <input type="text" name="shortcode" value={formData.shortcode} onChange={handleChange} />

                    <span>Shortcode</span>

                  </div>

                  <div className="inputBox">

                    <input type="text" name="surcon_number" value={formData.surcon_number} onChange={handleChange} />

                    <span>SURCON Number</span>

                  </div>

                </div>

                <div className="inputBox">

                  <input type="text" name="specialization" value={formData.specialization} onChange={handleChange} />

                  <span>Specialization</span>

                </div>

                <div className="inputBox full">

                  <input type="text" name="firm_name" value={formData.firm_name} onChange={handleChange} />

                  <span>Firm / Organisation Name</span>

                </div>

                <div className="inputBox full">

                  <textarea name="firm_address" value={formData.firm_address} onChange={handleChange} rows={2} />

                  <span className={formData.firm_address ? 'floated' : ''}>Office Address</span>

                </div>

                <div className="inputBox full">

                  <textarea name="academic_qualification" value={formData.academic_qualification} onChange={handleChange} rows={2} />

                  <span className={formData.academic_qualification ? 'floated' : ''}>Academic Qualification(s)</span>

                </div>

                <div className="checkboxRow">

                  <label className="checkbox-label">

                    <input type="checkbox" name="registered_with_nis_hq" checked={formData.registered_with_nis_hq} onChange={handleChange} />

                    <span className="checkmark" />

                    Registered with NIS Headquarters

                  </label>

                </div>

              </div>

            )}



            {/* Step 3: Confirmation */}

            {step === 3 && (

              <div className="step-content">

                <div className="section-title">Review &amp; Confirm</div>

                <div className="review-grid">

                  <div className="review-item"><strong>Name:</strong> {formData.first_name} {formData.last_name}</div>

                  <div className="review-item"><strong>Email:</strong> {formData.email}</div>

                  <div className="review-item"><strong>Phone:</strong> {formData.phone_number || '—'}</div>

                  <div className="review-item"><strong>Gender:</strong> {formData.gender || '—'}</div>

                  <div className="review-item"><strong>Date of Birth:</strong> {formData.date_of_birth || '—'}</div>

                  <div className="review-item"><strong>State of Origin:</strong> {formData.state_of_origin || '—'}</div>

                  <div className="review-item"><strong>Address:</strong> {formData.address || '—'}</div>

                  <div className="review-item"><strong>Category:</strong> {MEMBERSHIP_CATEGORIES.find(c => c.value === formData.membership_category)?.label || '—'}</div>

                  <div className="review-item"><strong>Membership No.:</strong> {formData.membership_number || '—'}</div>

                  <div className="review-item"><strong>Shortcode:</strong> {formData.shortcode || '—'}</div>

                  <div className="review-item"><strong>SURCON No.:</strong> {formData.surcon_number || '—'}</div>

                  <div className="review-item"><strong>Specialization:</strong> {formData.specialization || '—'}</div>

                  <div className="review-item"><strong>Firm:</strong> {formData.firm_name || '—'}</div>

                  <div className="review-item"><strong>NIS HQ Registered:</strong> {formData.registered_with_nis_hq ? 'Yes' : 'No'}</div>

                  <div className="review-item"><strong>Passport Photo:</strong> {photo ? photo.name : '—'}</div>

                </div>

                <div className="declaration">

                  <p>By registering, I declare that I will be loyal to the Nigerian Institution of Surveyors and uphold the ethics and ideals of the profession. I will abide by the constitution and rules of the Institution and the FCT Branch.</p>

                </div>

              </div>

            )}



            {/* Navigation */}

            <div className="nav-buttons">

              {step > 0 && (

                <button type="button" className="btn-back" onClick={prevStep}>Back</button>

              )}

              {step < STEPS.length - 1 ? (

                <button type="button" className="btn-next" onClick={nextStep}>Continue</button>

              ) : (

                <button type="submit" className="btn-submit" disabled={loading}>

                  {loading ? 'Submitting...' : 'Submit Registration'}

                </button>

              )}

            </div>

          </form>



          <p className="login-link">

            Already have an account?{' '}

            <Link to="/login">Sign in</Link>

          </p>

        </div>

      </div>

    </StyledWrapper>

  );

}



const StyledWrapper = styled.div`

  .container {

    min-height: 70vh;

    display: flex;

    align-items: center;

    justify-content: center;

    padding: 3rem 1rem;

    background: #F8FAFB;

  }



  .logo {

    width: auto;

    height: 80px;

    object-fit: contain;

    box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1);

  }



  .title {

    color: #0B5D1E;

    text-transform: uppercase;

    letter-spacing: 2px;

    display: block;

    font-weight: bold;

    font-size: x-large;

    font-family: 'Playfair Display', serif;

    text-align: center;

  }



  .subtitle {

    color: #6b7280;

    font-size: 0.875rem;

    margin-top: -15px;

    letter-spacing: 0.5px;

  }



  .card {

    display: flex;

    justify-content: center;

    align-items: center;

    width: 600px;

    max-width: 95vw;

    flex-direction: column;

    gap: 20px;

    background: #e3e3e3;

    box-shadow: 16px 16px 32px #c8c8c8,

          -16px -16px 32px #fefefe;

    border-radius: 12px;

    padding: 2.5rem 2rem;

  }



  /* ---- Stepper ---- */

  .stepper {

    display: flex;

    gap: 8px;

    width: 100%;

    justify-content: center;

  }



  .step-item {

    display: flex;

    flex-direction: column;

    align-items: center;

    flex: 1;

    max-width: 100px;

  }



  .step-circle {

    width: 32px;

    height: 32px;

    border-radius: 50%;

    border: 2px solid #aaa;

    display: flex;

    align-items: center;

    justify-content: center;

    font-size: 0.8rem;

    font-weight: 700;

    color: #aaa;

    background: transparent;

    transition: 0.3s;

  }



  .step-item.active .step-circle {

    border-color: #0B5D1E;

    color: #fff;

    background: #0B5D1E;

  }



  .step-item.done .step-circle {

    border-color: #0B5D1E;

    color: #0B5D1E;

    background: #d4edda;

  }



  .step-label {

    font-size: 0.65rem;

    margin-top: 4px;

    color: #6b7280;

    text-transform: uppercase;

    letter-spacing: 1px;

    font-weight: 600;

  }



  .step-item.active .step-label {

    color: #0B5D1E;

  }



  /* ---- Form ---- */

  form {

    display: flex;

    flex-direction: column;

    width: 100%;

  }



  .step-content {

    display: flex;

    flex-direction: column;

    gap: 18px;

    width: 100%;

  }



  .section-title {

    font-size: 0.75rem;

    text-transform: uppercase;

    letter-spacing: 2px;

    color: #0B5D1E;

    font-weight: 700;

    border-bottom: 2px solid #0B5D1E;

    padding-bottom: 6px;

  }



  .row {

    display: flex;

    gap: 16px;

  }



  @media (max-width: 520px) {

    .row {

      flex-direction: column;

    }

  }



  .row > * {

    flex: 1;

  }



  .inputBox {

    position: relative;

  }



  .inputBox.full {

    width: 100%;

  }



  .inputBox input,

  .inputBox textarea {

    width: 100%;

    padding: 12px;

    outline: none;

    border: none;

    color: #000;

    font-size: 1em;

    background: transparent;

    border-left: 2px solid #0B5D1E;

    border-bottom: 2px solid #0B5D1E;

    transition: 0.1s;

    border-bottom-left-radius: 8px;

    font-family: inherit;

    resize: vertical;

  }



  .inputBox span {

    margin-top: 5px;

    position: absolute;

    left: 0;

    transform: translateY(-4px);

    margin-left: 10px;

    padding: 10px;

    pointer-events: none;

    font-size: 12px;

    color: #374151;

    text-transform: uppercase;

    transition: 0.5s;

    letter-spacing: 3px;

    border-radius: 8px;

  }



  .inputBox input:valid ~ span,

  .inputBox input:focus ~ span,

  .inputBox input.has-value ~ span,

  .inputBox textarea:focus ~ span,

  .inputBox span.floated {

    transform: translateX(60px) translateY(-15px);

    font-size: 0.7em;

    padding: 4px 8px;

    background: #0B5D1E;

    letter-spacing: 0.15em;

    color: #fff;

    border: 2px;

  }



  .inputBox input:valid,

  .inputBox input:focus,

  .inputBox textarea:focus {

    border: 2px solid #0B5D1E;

    border-radius: 8px;

  }



  /* ---- Select ---- */

  .selectBox {

    display: flex;

    flex-direction: column;

    gap: 4px;

  }



  .selectBox label {

    font-size: 0.7rem;

    text-transform: uppercase;

    letter-spacing: 2px;

    color: #374151;

    font-weight: 600;

  }



  .selectBox select {

    padding: 11px 12px;

    border: 2px solid #0B5D1E;

    border-radius: 8px;

    background: transparent;

    font-size: 0.9rem;

    color: #000;

    outline: none;

    cursor: pointer;

  }



  /* ---- Checkbox ---- */

  .checkboxRow {

    padding-top: 4px;

  }



  .checkbox-label {

    display: flex;

    align-items: center;

    gap: 8px;

    font-size: 0.9rem;

    color: #374151;

    cursor: pointer;

    user-select: none;

  }



  .checkbox-label input[type="checkbox"] {

    accent-color: #0B5D1E;

    width: 18px;

    height: 18px;

    cursor: pointer;

  }



  /* ---- Photo Upload ---- */

  .photo-upload {

    display: flex;

    flex-direction: column;

    gap: 6px;

  }



  .photo-label {

    font-size: 0.7rem;

    text-transform: uppercase;

    letter-spacing: 2px;

    color: #374151;

    font-weight: 600;

  }



  .photo-area {

    position: relative;

    width: 130px;

    height: 150px;

    border: 2px dashed #0B5D1E;

    border-radius: 8px;

    overflow: hidden;

    cursor: pointer;

    display: flex;

    align-items: center;

    justify-content: center;

    transition: 0.3s;

  }



  .photo-area:hover {

    border-color: #1A7A35;

    background: rgba(11, 93, 30, 0.04);

  }



  .photo-area input[type="file"] {

    position: absolute;

    inset: 0;

    opacity: 0;

    cursor: pointer;

  }



  .photo-preview {

    width: 100%;

    height: 100%;

    object-fit: cover;

  }



  .photo-placeholder {

    display: flex;

    flex-direction: column;

    align-items: center;

    gap: 6px;

  }



  .photo-placeholder span {

    font-size: 0.7rem;

    color: #0B5D1E;

    font-weight: 600;

    text-transform: uppercase;

    letter-spacing: 1px;

  }



  .photo-hint {

    font-size: 0.7rem;

    color: #9ca3af;

  }



  /* ---- Review ---- */

  .review-grid {

    display: grid;

    grid-template-columns: 1fr 1fr;

    gap: 10px;

  }



  @media (max-width: 520px) {

    .review-grid {

      grid-template-columns: 1fr;

    }

  }



  .review-item {

    font-size: 0.85rem;

    color: #374151;

    padding: 6px 0;

    border-bottom: 1px solid #d1d5db;

  }



  .review-item strong {

    color: #0B5D1E;

    font-weight: 600;

  }



  .declaration {

    margin-top: 8px;

    padding: 14px;

    background: rgba(11, 93, 30, 0.06);

    border-left: 3px solid #0B5D1E;

    border-radius: 4px;

  }



  .declaration p {

    font-size: 0.8rem;

    color: #374151;

    line-height: 1.6;

    margin: 0;

  }



  /* ---- Buttons ---- */

  .nav-buttons {

    display: flex;

    justify-content: space-between;

    margin-top: 24px;

    gap: 12px;

  }



  .btn-back,

  .btn-next,

  .btn-submit {

    height: 46px;

    padding: 0 28px;

    border-radius: 8px;

    border: 2px solid #0B5D1E;

    cursor: pointer;

    text-transform: uppercase;

    font-size: 0.8rem;

    font-weight: 600;

    letter-spacing: 2px;

    transition: 0.3s;

  }



  .btn-back {

    background: transparent;

    color: #0B5D1E;

  }



  .btn-back:hover {

    background: rgba(11, 93, 30, 0.08);

  }



  .btn-next {

    background: transparent;

    color: #0B5D1E;

    margin-left: auto;

  }



  .btn-next:hover {

    background: #0B5D1E;

    color: #fff;

  }



  .btn-submit {

    background: #0B5D1E;

    color: #fff;

    margin-left: auto;

  }



  .btn-submit:hover {

    background: #094A18;

  }



  .btn-submit:disabled {

    opacity: 0.5;

    cursor: not-allowed;

  }



  /* ---- Footer link ---- */

  .login-link {

    font-size: 0.875rem;

    color: #6b7280;

    margin-top: -5px;

  }



  .login-link a {

    color: #0B5D1E;

    font-weight: 600;

    text-decoration: none;

    transition: 0.2s;

  }



  .login-link a:hover {

    color: #1A7A35;

  }

`;

